export const validateEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  // eslint-disable-next-line
  return /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/im.test(
    phoneNumber
  )
}

export const validatePassword = (password: string): boolean => {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_+~=])[A-Za-z\d!@#$%^&*()\-_+~=]{12,}$/.test(password)
}

export const validateZip = (zip: string): boolean => {
  return /^\d{5}([-]|\s*)?(\d{4})?$/.test(zip)
}

export const validateNonNumeric = (toValidate: string): boolean => {
  return /^\D+$/.test(toValidate)
}
